import React, { useState, useEffect } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  List,
  ListItem,
  ListItemText,
  Checkbox,
  ListItemIcon,
  Button,
  DialogActions,
} from "@mui/material";
import { db } from "../firebase-config";
import { collection, getDocs } from "firebase/firestore";

const CategorySelectPopup = ({ open, onClose, onSelectCategory, selectedCategories }) => {
  const [categories, setCategories] = useState([]);
  const [selected, setSelected] = useState([]);

  useEffect(() => {
    const fetchCategories = async () => {
      const categoriesRef = collection(db, "Categories");
      const snapshot = await getDocs(categoriesRef);
      const categoryList = snapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));
      setCategories(categoryList);
    };

    if (open) {
      fetchCategories();
      setSelected(selectedCategories || []);
    }
  }, [open, selectedCategories]);

  const toggleSelect = (category) => {
    setSelected((prev) =>
      prev.some((c) => c.id === category.id)
        ? prev.filter((c) => c.id !== category.id)
        : [...prev, category]
    );
  };

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>Select Categories</DialogTitle>
      <DialogContent>
        <List>
          {categories.map((category) => (
            <ListItem
              key={category.id}
              button
              onClick={() => toggleSelect(category)}
            >
              <ListItemIcon>
                <Checkbox checked={selected.some((c) => c.id === category.id)} />
              </ListItemIcon>
              <ListItemText primary={category.name || "No Name"} />
            </ListItem>
          ))}
        </List>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button
          onClick={() => {
            onSelectCategory(selected);
            onClose();
          }}
          color="primary"
        >
          Confirm
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default CategorySelectPopup;
